import { DEFAULT_ALERT_CONFIG, DEFAULT_IA_CONFIG } from "./config.js";

export const state = {
  page: "dashboard",
  usuarioRol: null,     // admin | vendedor | compras | contabilidad | tesoreria
  usuarioNombre: null,
  usuarioEmail: null,
  _mfaEnroll: null,     // { factorId, qr, secret } mientras se está registrando un factor TOTP nuevo
  data: {
    clientes:[], proveedores:[], productos:[],
    cotizaciones:[], pedidos:[], ocp:[], requisiciones:[], recepciones:[], apartados:[], remisiones:[], inventario:[], puc:[], asientos:[], alertas_enviadas:[],
    cuentas_pagar:[], cuentas_cobro:[]
  },
  modal: null,
  searches: { maestros:"", docs:"" },
  reporteFiltros: {},
  reporteDetalleOP: null,
  reporteVigencia: false,          // ← AGREGADO: Reporte de vigencia
  maestrosTab: "clientes",         // ← AGREGADO: Tab de maestros
  editingDoc: null,                // ← AGREGADO: Documento en edición
  editingMaestro: null,            // ← AGREGADO: Maestro en edición
  editingMaestroKey: null,         // ← AGREGADO: Clave de maestro en edición
  editingTipo: null,               // ← AGREGADO: Tipo de documento en edición
  confirmAction: null,             // ← AGREGADO: Acción de confirmación
  selectedDocs: {},                 // { tipo: { docId: true, ... } }
  trazaAbierta: null,               // "TIPO:id" del documento con la trazabilidad desplegada (uno a la vez)
  alertConfig: { ...DEFAULT_ALERT_CONFIG },
  alertasFiltroTipo: "todos",        // ← AGREGADO: Filtro por tipo de documento en Centro de Alertas
  alertasSeleccionadas: {},          // ← AGREGADO: { key: true } alertas marcadas para envío unificado
  alertasTab: "pendientes",          // ← AGREGADO: pestaña activa en Centro de Alertas ("pendientes" | "enviadas")
  alertasEnviadasFiltroTipo: "todos", // ← AGREGADO: Filtro por tipo de documento en la pestaña de alertas enviadas

  // ─── DASHBOARD ──────────────────────────────────────────────────────
  dashMargenPeriodo: "mes",           // día | semana | mes | trimestre | semestre | anio | todo

  // ─── COMISIONES ─────────────────────────────────────────────────────
  comisionesFiltro: { vendedor: "", desde: "", hasta: "", rango: "todos" },
  comisionesTab: "liquidacion",   // "liquidacion" | "tabla"
  editandoTablaComisiones: false,

  // ─── ASISTENTE IA ───────────────────────────────────────────────────
  iaConfig: { ...DEFAULT_IA_CONFIG },
  iaInput: "",
  iaImages: [],          // [{ id, nombre, mediaType, base64 }]
  iaResultado: null,      // respuesta JSON parseada de la IA
  iaError: null,
  iaLoading: false
};
